<template>
  <TheModal :show="show" size="lg" @close="$emit('close')">
    <LandingLeadFunnel ref="funnelRef" embedded @completed="onCompleted" />
  </TheModal>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue'
import TheModal from '@/components/TheModal.vue'
import LandingLeadFunnel from '@/components/landing/LandingLeadFunnel.vue'

const props = defineProps({
  show: { type: Boolean, default: false },
})

defineEmits(['close'])

const funnelRef = ref(null)

watch(
  () => props.show,
  async (open) => {
    if (!open) return
    await nextTick()
    funnelRef.value?.resetFunnel?.()
  },
)

function onCompleted() {
  /* Экран «Спасибо» внутри воронки — без редиректа */
}
</script>

<style scoped>
:deep(.modal-body) {
  padding-top: 0.5rem !important;
}
</style>
